import type { Transition, Variants } from 'motion/react'

export const MODAL_WRAPPER_ANIMATION: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
}

export const MODAL_CONTENT_ANIMATION: Variants = {
  initial: { scale: 0.8, opacity: 0, y: -20 },
  animate: { scale: 1, opacity: 1, y: 0 },
  exit: { scale: 0.8, opacity: 0, y: -20 }
}

export const SELECTED_BANNER_ANIMATION: Variants = {
  initial: { scale: 0.8, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.8, opacity: 0 }
}

export const SPRING_TRANSITION: Transition = {
  duration: 0.2,
  type: 'spring',
  damping: 20,
  stiffness: 300
}

export const FADE_TRANSITION: Transition = {
  duration: 0.2
}
